import axios from "axios";

export const qwDimensions = axios.create({
  baseURL: process.env.QW_DIMENSIONS_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

qwDimensions.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && process.env.HOME_PAGE_URL) {
      window.location.href = process.env.HOME_PAGE_URL;
    }
    return Promise.reject(error);
  },
);
